(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["invictus-lookbook-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLookbook(root) {
      if (!root || root.__invictusLookbookInit) return;
      root.__invictusLookbookInit = true;

      var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // ----- Photo scroll-reveal -----
      var photos = root.querySelectorAll('.invictus-lookbook__photo');
      if ('IntersectionObserver' in window && !prefersReduced) {
        var revealIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealIo.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
        photos.forEach(function (p) { revealIo.observe(p); });
      } else {
        photos.forEach(function (p) { p.classList.add('is-visible'); });
      }

      // ----- Lightbox -----
      var lightbox = root.querySelector('[data-invictus-lightbox]');
      var lightboxImg = root.querySelector('[data-invictus-lightbox-img]');
      var lightboxCaption = root.querySelector('[data-invictus-lightbox-caption]');
      var openers = Array.from(root.querySelectorAll('[data-invictus-lightbox-open]'));
      var currentIndex = -1;

      function openLightbox(index) {
        if (!lightbox || !openers.length) return;
        currentIndex = ((index % openers.length) + openers.length) % openers.length;
        var btn = openers[currentIndex];
        var src = btn.getAttribute('data-img');
        var caption = btn.getAttribute('data-caption') || '';
        if (lightboxImg) {
          lightboxImg.src = src;
          lightboxImg.alt = caption;
        }
        if (lightboxCaption) lightboxCaption.textContent = caption;
        lightbox.hidden = false;
        lightbox.setAttribute('data-open', 'true');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function closeLightbox() {
        if (!lightbox) return;
        lightbox.removeAttribute('data-open');
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        if (lightboxImg) lightboxImg.src = '';
        document.body.style.overflow = '';
      }
      function nextLightbox() { openLightbox(currentIndex + 1); }
      function prevLightbox() { openLightbox(currentIndex - 1); }

      openers.forEach(function (btn, idx) {
        btn.addEventListener('click', function () { openLightbox(idx); });
      });

      var closeBtn = root.querySelector('[data-invictus-lightbox-close]');
      var prevBtn = root.querySelector('[data-invictus-lightbox-prev]');
      var nextBtn = root.querySelector('[data-invictus-lightbox-next]');
      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
      if (prevBtn) prevBtn.addEventListener('click', prevLightbox);
      if (nextBtn) nextBtn.addEventListener('click', nextLightbox);
      if (lightbox) {
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) closeLightbox();
        });
      }
      document.addEventListener('keydown', function (e) {
        if (!lightbox || !lightbox.hasAttribute('data-open')) return;
        if (e.key === 'Escape') closeLightbox();
        else if (e.key === 'ArrowRight') nextLightbox();
        else if (e.key === 'ArrowLeft') prevLightbox();
      });

      if (lightbox) {
        var touchStartX = 0;
        lightbox.addEventListener('touchstart', function (e) {
          if (e.touches && e.touches[0]) touchStartX = e.touches[0].clientX;
        }, { passive: true });
        lightbox.addEventListener('touchend', function (e) {
          if (!e.changedTouches || !e.changedTouches[0]) return;
          var dx = e.changedTouches[0].clientX - touchStartX;
          if (dx > 60) prevLightbox();
          else if (dx < -60) nextLightbox();
        }, { passive: true });
      }

      // ----- Intro: scramble decoder + glitch flicker + reveal -----
      var introEl = root.querySelector('[data-invictus-intro]');
      var headingEl = root.querySelector('[data-invictus-scramble]');
      if (introEl && headingEl && !prefersReduced) {
        var finalText = headingEl.getAttribute('data-final') || headingEl.textContent;
        var scrambleChars = '!@#$%&*=+<>?/|░▒▓█▚▞✕';
        function scramble(el, target) {
          var iter = 0;
          var maxIter = 22;
          var len = target.length;
          function frame() {
            var out = '';
            for (var i = 0; i < len; i++) {
              var ch = target[i];
              if (ch === ' ' || ch === '/') {
                out += ch;
              } else if (iter / maxIter > i / len) {
                out += ch;
              } else {
                out += scrambleChars[Math.floor(Math.random() * scrambleChars.length)];
              }
            }
            el.textContent = out;
            iter++;
            if (iter <= maxIter + len * 0.4) {
              requestAnimationFrame(frame);
            } else {
              el.textContent = target;
              introEl.classList.add('is-revealed');
              startGlitchLoop();
            }
          }
          frame();
        }
        function startGlitchLoop() {
          function tick() {
            var delay = 7000 + Math.random() * 6000;
            setTimeout(function () {
              headingEl.classList.add('is-glitching');
              setTimeout(function () {
                headingEl.classList.remove('is-glitching');
                tick();
              }, 420);
            }, delay);
          }
          tick();
        }
        if ('IntersectionObserver' in window) {
          var introIo = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                scramble(headingEl, finalText);
                introIo.unobserve(entry.target);
              }
            });
          }, { threshold: 0.3 });
          introIo.observe(introEl);
        } else {
          scramble(headingEl, finalText);
        }
      } else if (introEl) {
        introEl.classList.add('is-revealed');
      }

      // ----- Menu overlay -----
      var menuToggle = root.querySelector('[data-invictus-menu-toggle]');
      var menuOverlay = root.querySelector('[data-invictus-menu]');
      var menuClose = root.querySelector('[data-invictus-menu-close]');
      function openMenu() {
        if (!menuOverlay) return;
        menuOverlay.hidden = false;
        menuOverlay.setAttribute('data-open', 'true');
        menuOverlay.setAttribute('aria-hidden', 'false');
        if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      }
      function closeMenu() {
        if (!menuOverlay) return;
        menuOverlay.setAttribute('data-open', 'false');
        menuOverlay.setAttribute('aria-hidden', 'true');
        if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        setTimeout(function () {
          if (menuOverlay.getAttribute('data-open') === 'false') menuOverlay.hidden = true;
        }, 320);
      }
      if (menuToggle) menuToggle.addEventListener('click', openMenu);
      if (menuClose) menuClose.addEventListener('click', closeMenu);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && menuOverlay && menuOverlay.getAttribute('data-open') === 'true') closeMenu();
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-invictus-lookbook]').forEach(initLookbook);
    });
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector('[data-invictus-lookbook]');
      if (sec) initLookbook(sec);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["invictus-story-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-invictus-story]').forEach(function (root) {
      var btn = root.querySelector('[data-invictus-menu-toggle]');
      var menu = root.querySelector('[data-invictus-menu]');
      var close = root.querySelector('[data-invictus-menu-close]');

      if (btn && menu) {
        var open = function () {
          menu.removeAttribute('hidden');
          menu.setAttribute('data-open', 'true');
          menu.setAttribute('aria-hidden', 'false');
          btn.setAttribute('aria-expanded', 'true');
          document.body.classList.add('invictus-menu-open');
        };
        var shut = function () {
          menu.setAttribute('data-open', 'false');
          menu.setAttribute('aria-hidden', 'true');
          btn.setAttribute('aria-expanded', 'false');
          document.body.classList.remove('invictus-menu-open');
          setTimeout(function () { menu.setAttribute('hidden', ''); }, 300);
        };
        btn.addEventListener('click', function () {
          (btn.getAttribute('aria-expanded') === 'true') ? shut() : open();
        });
        if (close) close.addEventListener('click', shut);
        menu.addEventListener('click', function (e) { if (e.target === menu) shut(); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') shut();
        });
      }

      // Cursor-tracking red light leak + quote proximity reveal
      var quoteEl = root.querySelector('.invictus-story__quote');
      var quoteRevealRadius = 280; // px from quote bounding box for reveal trigger
      if (!prefersReduced) {
        var cursorLayer = root.querySelector('[data-invictus-cursor]');
        var rafId = 0;
        var nextX = 50, nextY = 50, lastClientX = 0, lastClientY = 0;
        var tick = function () {
          rafId = 0;
          root.style.setProperty('--invictus-cursor-x', nextX + '%');
          root.style.setProperty('--invictus-cursor-y', nextY + '%');
          if (quoteEl) {
            var qr = quoteEl.getBoundingClientRect();
            var dx = Math.max(qr.left - lastClientX, 0, lastClientX - qr.right);
            var dy = Math.max(qr.top - lastClientY, 0, lastClientY - qr.bottom);
            var dist = Math.hypot(dx, dy);
            quoteEl.setAttribute('data-near', dist < quoteRevealRadius ? 'true' : 'false');
          }
        };
        var schedule = function () { if (!rafId) rafId = requestAnimationFrame(tick); };
        root.addEventListener('mousemove', function (e) {
          var rect = root.getBoundingClientRect();
          nextX = ((e.clientX - rect.left) / rect.width) * 100;
          nextY = ((e.clientY - rect.top) / rect.height) * 100;
          lastClientX = e.clientX; lastClientY = e.clientY;
          schedule();
        });
        root.addEventListener('mouseleave', function () {
          nextX = 50; nextY = 50;
          lastClientX = -9999; lastClientY = -9999;
          schedule();
        });
        root.addEventListener('touchmove', function (e) {
          if (!e.touches || !e.touches[0]) return;
          var rect = root.getBoundingClientRect();
          nextX = ((e.touches[0].clientX - rect.left) / rect.width) * 100;
          nextY = ((e.touches[0].clientY - rect.top) / rect.height) * 100;
          lastClientX = e.touches[0].clientX; lastClientY = e.touches[0].clientY;
          schedule();
        }, { passive: true });
      }

      // Scroll-reveal for story rows
      var rows = root.querySelectorAll('.invictus-row');
      if (prefersReduced || !('IntersectionObserver' in window)) {
        rows.forEach(function (r) { r.classList.add('is-visible'); });
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
        rows.forEach(function (r) { io.observe(r); });
      }

      // Quote scroll-trigger reveal — primary mechanism on touch devices,
      // and a graceful fallback for any visitor whose cursor never lingers.
      if (quoteEl && 'IntersectionObserver' in window) {
        var quoteIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.setAttribute('data-near', 'true');
            }
          });
        }, { threshold: 0.35 });
        quoteIo.observe(quoteEl);
      } else if (quoteEl) {
        quoteEl.setAttribute('data-near', 'true');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kpanda-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (typeof IntersectionObserver === 'undefined') {
      document.querySelectorAll('[data-kpanda-contact] .reveal, [data-kpanda-contact] [data-stagger]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('[data-kpanda-contact] .reveal, [data-kpanda-contact] [data-stagger]').forEach(function (el) {
      io.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kpanda-policy-shopify"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-kpanda-policy].kpanda-policy--shopify');
    if (!root) return;
    if (typeof IntersectionObserver === 'undefined') {
      root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
    root.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kpanda-policy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-kpanda-policy]');
    if (!root) return;

    /* Reveal on enter */
    if (typeof IntersectionObserver !== 'undefined') {
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealIO.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      root.querySelectorAll('.reveal').forEach(function (el) { revealIO.observe(el); });
    } else {
      root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* Scroll-spy: highlight rail link for the clause currently in view */
    var clauses = root.querySelectorAll('[data-clause]');
    var railLinks = root.querySelectorAll('.kpanda-policy__rail-list a');
    if (clauses.length === 0 || railLinks.length === 0 || typeof IntersectionObserver === 'undefined') return;

    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var id = entry.target.id;
          railLinks.forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
          });
        }
      });
    }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });

    clauses.forEach(function (c) { spy.observe(c); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-policies"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-kpanda-policy].kpanda-policy--shopify');
    if (!root) return;
    if (typeof IntersectionObserver === 'undefined') {
      root.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
    root.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();
})();
